import { render, staticRenderFns } from "./Discovery.vue?vue&type=template&id=f4430e3a&scoped=true"
import script from "./Discovery.vue?vue&type=script&lang=js"
export * from "./Discovery.vue?vue&type=script&lang=js"
import style0 from "./Discovery.vue?vue&type=style&index=0&id=f4430e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4430e3a",
  null
  
)

export default component.exports